import Http from '../http'

export default {

  index(filter) {
    return Http.get(`/activities`, {params: {...filter}})
  },

  indexByEvent({event_id, filter}) {
    return Http.get(`/events/${event_id}/activities`, {params: {...filter}})
  },


  create(activity){
    return Http.post(`/activities`, activity)
  },

  update(activity){
    return Http.put(`/activities/${activity.get('activity[id]')}`, activity)
  },

  show(id) {
    return Http.get(`/activities/${id}`);
  },

  delete(id){
    return Http.delete(`/activities/${id}`)
  }

}